module.exports = __webpack_public_path__ + "img/venus24.0aaf34fc.png";